export default {
  countries: [
    "Anguilla",
    "Saint Martin",
    "Sint Maarten",
    "Saint Barthelemy",
    "Saba",
    "Antigua And Barbuda",
    "Sint Eustatius",
    "Saint Kitts and Nevis",
    "Montserrat",
    "Guadeloupe",
    "Dominica",
    "Martinique",
    "Saint Lucia",
    "Barbados",
    "Saint Vincent and the Grenadines",
    "Grenada",
  ],
};
